import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function addProjectToUser(id, projectList) {
	var userProject = firebaseRef.ref('/users/' + id + '/projectRoles');

	// project list
	// [{key: 'ambria_aurora', label: 'Ambria Aurora', role: 'admin'}]

	console.log('addProjectToUser', id, projectList);

	var projectRole = {};

	projectList?.forEach((key) => {
		console.log('this is the key', key);
		var project = key;

		var projectId = project.key;
		var role = project.role;

		projectRole = {
			...projectRole,
			[projectId]: role,
		};
	});

	console.log('projectRole', projectRole);

	userProject.set(projectRole);
}
